"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydrateProductsTableQueryState = exports.productsFieldHydrators = void 0;
const product_tree_nodes_1 = require("../../../../../client/product-tree-nodes");
const view_query_params_1 = require("../../../../../common/view-query-params");
const models_1 = require("../../../../../models");
const products_table_1 = require("../../../../../store/catalogs/products-table");
const table_config_1 = require("../../../../../store/shared/table-config");
const store_1 = require("../../../../../../store");
const productsHydrationOrder = [
    view_query_params_1.ViewQueryStateField.DynamicColumns,
    view_query_params_1.ViewQueryStateField.Filter,
    view_query_params_1.ViewQueryStateField.Search,
    view_query_params_1.ViewQueryStateField.Sort,
    view_query_params_1.ViewQueryStateField.PageSize,
    view_query_params_1.ViewQueryStateField.SelectedTreeNodePath,
    view_query_params_1.ViewQueryStateField.MiddleSectionFilter,
];
const getExpandedAttributes = (attributeName, collapseState = models_1.CollapseState.Collapse, expandedAttributes = []) => {
    const nextExpandedAttributes = new Set(expandedAttributes);
    if (collapseState === models_1.CollapseState.Collapse) {
        nextExpandedAttributes.add(attributeName);
    }
    else {
        nextExpandedAttributes.delete(attributeName);
    }
    return Array.from(nextExpandedAttributes);
};
exports.productsFieldHydrators = {
    [view_query_params_1.ViewQueryStateField.Filter]: ({ catalogId, dispatch, state }) => {
        dispatch((0, products_table_1.setProductsTableFilter)(catalogId, state[view_query_params_1.ViewQueryStateField.Filter]));
    },
    [view_query_params_1.ViewQueryStateField.Search]: ({ catalogId, dispatch, state }) => {
        dispatch((0, products_table_1.setProductsTableSearch)(catalogId, state[view_query_params_1.ViewQueryStateField.Search]));
    },
    [view_query_params_1.ViewQueryStateField.Sort]: ({ catalogId, dispatch, state }) => {
        dispatch((0, products_table_1.setProductsTableSort)(catalogId, state[view_query_params_1.ViewQueryStateField.Sort]));
    },
    [view_query_params_1.ViewQueryStateField.PageSize]: ({ catalogId, dispatch, state }) => {
        dispatch((0, products_table_1.setProductsTablePageSize)(catalogId, state[view_query_params_1.ViewQueryStateField.PageSize]));
    },
    [view_query_params_1.ViewQueryStateField.DynamicColumns]: ({ catalogId, dispatch, state }) => {
        dispatch((0, products_table_1.setProductsDynamicTableColumns)(catalogId, Object.assign(Object.assign({}, table_config_1.defaultTableState.dynamicColumns), state[view_query_params_1.ViewQueryStateField.DynamicColumns])));
    },
    [view_query_params_1.ViewQueryStateField.MiddleSectionFilter]: ({ attributesCollapseState, dispatch, expandedAttributes, state, }) => {
        const selectedAttributeNode = state[view_query_params_1.ViewQueryStateField.MiddleSectionFilter];
        dispatch((0, store_1.enrichAISetSelectedAttributeNode)(selectedAttributeNode));
        if (selectedAttributeNode === null || selectedAttributeNode === void 0 ? void 0 : selectedAttributeNode.label) {
            dispatch((0, store_1.enrichAISetAttributesExcludedItems)(getExpandedAttributes(selectedAttributeNode.label, attributesCollapseState, expandedAttributes)));
        }
    },
    [view_query_params_1.ViewQueryStateField.SelectedTreeNodePath]: ({ dispatch, expandedNodes, state }) => {
        const selectedTreeNodePath = state[view_query_params_1.ViewQueryStateField.SelectedTreeNodePath];
        dispatch((0, store_1.enrichAISetSelectedTreeNodePath)(selectedTreeNodePath));
        const expanded = new Set([
            ...(0, product_tree_nodes_1.getExpandedNodesListByPath)(selectedTreeNodePath),
            ...(expandedNodes !== null && expandedNodes !== void 0 ? expandedNodes : []),
        ]);
        dispatch((0, store_1.enrichAISetExpandedNodes)(Array.from(expanded)));
    },
};
const hydrateProductsTableQueryState = (context) => {
    productsHydrationOrder.forEach((field) => {
        if (field in context.state) {
            exports.productsFieldHydrators[field](context);
        }
    });
};
exports.hydrateProductsTableQueryState = hydrateProductsTableQueryState;
